import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const LightShape = ({ width = 36, height = 36, style }: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 4.58366C14.0375 4.58366 16.5 7.04609 16.5 10.0837C16.5 12.1194 15.3939 13.8969 13.75 14.8478L13.75 18.3337L12.8333 19.2503H11.9166C11.9166 19.7566 11.5062 20.167 11 20.167C10.4937 20.167 10.0833 19.7566 10.0833 19.2503H9.16665L8.24998 18.3337L8.24996 14.8478C6.60602 13.8969 5.49998 12.1194 5.49998 10.0837C5.49998 7.04609 7.96241 4.58366 11 4.58366ZM11.9167 15.5076C11.6186 15.5576 11.3123 15.5837 11 15.5837C10.6876 15.5837 10.3814 15.5576 10.0833 15.5076L10.0833 17.417H11.9166L11.9167 15.5076ZM5.97657 14.1348L6.94885 15.1071L5.0043 17.0516L4.03203 16.0793L5.97657 14.1348ZM16.0234 14.1348L17.9679 16.0793L16.9957 17.0516L15.0511 15.1071L16.0234 14.1348ZM20.1666 9.39616V10.7712H17.4166V9.39616H20.1666ZM4.58331 9.39616V10.7712H1.83331V9.39616H4.58331ZM16.9957 3.11571L17.9679 4.08798L16.0234 6.03253L15.0511 5.06025L16.9957 3.11571ZM5.0043 3.11571L6.94885 5.06025L5.97657 6.03253L4.03203 4.08798L5.0043 3.11571ZM11.6875 0.916992V3.66699H10.3125V0.916992H11.6875Z"
      fill="black"
    />
  </svg>
);

export default LightShape;
